import { render, staticRenderFns } from "./SOVDetailNew.vue?vue&type=template&id=9661555c&scoped=true"
import script from "./SOVDetailNew.vue?vue&type=script&lang=js"
export * from "./SOVDetailNew.vue?vue&type=script&lang=js"
import style0 from "./SOVDetailNew.vue?vue&type=style&index=0&id=9661555c&prod&lang=css"
import style1 from "./SOVDetailNew.vue?vue&type=style&index=1&id=9661555c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9661555c",
  null
  
)

export default component.exports